import { FC } from 'react';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { handleOpenDocument } from 'services/utils';
import { InputWrapper } from 'containers/CourtManagerAssignedExpertise/style';

interface TextElementProps {
  document: any;
  requestGetDocByDocumentumId: Function;
}

const ConvocationElement: FC<TextElementProps> = props => {
  const { document } = props;
  return (
    <InputWrapper>
      <h3>Convocation</h3>
      <Document
        name={document?.name}
        type={document?.type}
        icon={
          <VisibilityIcon
            className="consult"
            onClick={handleOpenDocument(
              document,
              props.requestGetDocByDocumentumId,
            )}
          />
        }
      />
    </InputWrapper>
  );
};

export default ConvocationElement;
